export const KAKAO_MAP_REST_API_KEY = "2cfaeeee24cf1409d4f8fe202ab57261";
export const MASK_URL =
  "https://8oi9s0nnth.apigw.ntruss.com/corona19-masks/v1/storesByGeo/json";
